<template>
  <div class="upload-file" v-loading="uploadLoading" ref="img">
    <p v-if="name" class="upload-file-name">{{ name }}</p>
    <el-image
      v-if="preview"
      :src="preview"
      :preview-src-list="previewList"
      @click="getUrl(preview)"
    ></el-image>

    <div v-else class="el-image">
      <img class="el-image__inner" src="@/assets/noPhoto.png" alt="没有图片" />
    </div>
    <el-upload
      action
      v-bind="$attrs"
      v-on="$listeners"
      ref="upload"
      :accept="accept"
      :disabled="readonly"
      :file-list="fileList"
      :show-file-list="false"
      :http-request="onHTTPRequest"
    >
      <div class="upload-buttons" v-if="!readonly">
        <el-button
          v-if="initialization"
          class="remove"
          @click.stop="$removePreview"
          >删除</el-button
        >
        <el-button class="upload">{{
          initialization ? '更改' : '上传'
        }}</el-button>
      </div>
    </el-upload>
  </div>
</template>

<script>
import OSS from 'ali-oss'
export default {
  name: 'upload-file',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
      comment: '显示的图片地址'
    },
    name: {
      type: String,
      comment: '图片描述'
    },
    limit: {
      type: Number,
      default: 2,
      comment: '限制的上传图片的个数'
    },
    accept: {
      type: String,
      default: 'image/png, image/jpg, image/gif, image/jpeg, image/pdf',
      comment: '接收的文件类型'
    },
    config: {
      type: Object,
      default() {
        return {}
      },
      comment: '阿里OSS上传文件配置项'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否只读(不可上传图片和修改图片仅可查看大图)'
    },
    previewList: {
      type: Array,
      default() {
        return []
      },
      comment: '点击预览图时显示的预览图片列表'
    },
    index: {
      type: Number,
      default() {
        return 999
      },
      comment: '图片下标'
    }
  },

  data() {
    return {
      curFileName: '',
      uploadLoading: false,
      preview: this.value,
      fileList: []
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal) {
          if (!newVal.includes('data:image') && newVal !== this.curFileName) {
            this.preview = newVal
          }
        }
      }
    }
  },

  computed: {
    initialization() {
      return this.preview && this.value
    }
  },
  // created() {
  //   console.log('this', this)
  // },

  methods: {
    // 选择图片以后进行校验
    onHTTPRequest({ file }) {
      console.log('上传图片步骤1')
      // console.log(file, 'file')
      // console.log(config, 'config')
      const { config, preview } = this
      if (!Object.keys(config).length) {
        console.log('配置文件初始化失败!')
        this.$emit('error', '配置文件初始化失败!')
        return false
      }

      const MAX_FILE_SIZE = 1024 * 1024
      const NAME_SUFFIX = file.name.split('.')
      const FILE_NAME = `${NAME_SUFFIX[0]}_${file.uid}.${NAME_SUFFIX.slice(-1)}`
      // console.log(FILE_NAME, '文件名称')

      // 允许选择的文件格式
      const ACCEPT_FILE_TYPES = [
        'image/png',
        'image/gif',
        'image/jpg',
        'image/jpeg',
        ' image/pdf'
      ]

      if (!~ACCEPT_FILE_TYPES.indexOf(file.type)) {
        console.log('不支持的文件格式!')
        this.$alert.error('不支持的文件格式!')
        return false
      }

      if (file.size > MAX_FILE_SIZE) {
        console.log('图片最大不能超过1MB')
        this.$alert.error('图片最大不能超过1MB!')
        return false
      }

      // 清除原来上传的任务队列
      // this.$removePreview()

      // 生成预览照片
      this.$fileToBase64(file).then(previewStr => {
        // console.log('生成预览照片', previewStr)
        if (file.type !== 'application/pdf') {
          // console.log(previewStr == preview, '===')
          this.preview = previewStr
          this.uploadLoading = true
          // console.log(previewStr == preview, '===')
          // this.$alert.error('只能上传pdf格式')
        } else {
          console.log('pdf格式')
        }

        try {
          this.$emit('add', true)
          const OSSClient = new OSS(config)
          // console.log(OSSClient, 'OSSCLIENT')
          const putResult = OSSClient.put(FILE_NAME, file).then(res => {
            this.$emit('input', FILE_NAME)
            this.$emit('success', res)
            this.curFileName = FILE_NAME
            this.$emit('curfilename', this.curFileName)
            // console.log(this.curFileName, 'curFileName')
          })
        } catch (e) {
          // console.log('aaa')
          this.$removePreview()
          this.$alert.error('图片上传失败! 请重试')
          this.$emit('error', e)
        }

        this.uploadLoading = false
      })
    },

    // 图片生成预览图
    $fileToBase64(file) {
      console.log('上传图片步骤2')
      const _self = this
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file, 'UTF-8')

      return new Promise(resolve => {
        fileReader.onload = function() {
          resolve(fileReader.result)
        }
      })
    },

    // 删除预览图及清空状态
    $removePreview() {
      // console.log(this.index, '===')
      this.previewList[this.index] = ''
      this.$emit('changePreviewList', this.previewList)
      // console.log(this.previewList, 'priverList')
      this.$data.preview = ''
      this.fileList.length = 0
      this.$refs.upload.clearFiles()
    },

    // 上传图片
    $addPreview() {
      this.$emit('add', true)
    },

    // 点击图片
    getUrl(preview) {
      this.$nextTick(() => {
        console.log(this.$refs.img)
        // this.$refs.img.previewSrcList
      })
      // this.$emit('previewUrl',preview)
    }
  }
}
</script>

<style lang="scss" scoped>
.upload-file {
  position: relative;
  display: inline-block;
  width: calc(20% - 30px);
  min-width: calc(20% - 30px);
  height: 235px;
  margin: 15px;
  overflow: hidden;
  font-size: 14px;
  color: #333;

  &-name {
    height: 30px;
    line-height: 30px;
    text-align: center;
  }

  /deep/ .el-image {
    display: flex;
    width: 100%;
    height: calc(100% - 30px);
    justify-content: center;
    align-items: center;
    overflow: hidden;

    &__inner,
    &__preview {
      width: 100%;
      height: auto;
    }
  }

  .upload-buttons {
    display: flex;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 35px;
    line-height: 35px;
    background: rgba(0, 0, 0, 0.48);
    color: #fff;

    .el-button {
      width: 100%;
      height: 100%;
      border: 0;
      margin: 0;
      outline: 0;
      padding: 0;
      border-radius: 0;
      background: none;

      &.upload {
        color: #fff;
      }

      &.remove {
        color: #ff5656;
      }
    }

    .el-button + .el-button {
      border-left: 1px solid #fff;
    }
  }
}
</style>
